// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnListItem from './part-return-list-item';

const PartReturnList = props =>
    <ul className='part-return-list'>
        <ListViewShowMore
            initialShowItems={50}
            perMoreMultiplier={1.25}
            showAllOption={true}
            showPerMore={50}
            totalItems={props.partReturns.length}
        >
            {props.partReturns.map((partReturn, index) => (
                <PartReturnListItem
                    item={partReturn}
                    key={index}
                />
            ))}
        </ListViewShowMore>
    </ul>;

PartReturnList.displayName = 'PartReturnList';
PartReturnList.propTypes = {
    partReturns: PropTypes.arrayOf(PropTypes.instanceOf(PartReturn)).isRequired
};

export default PartReturnList;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-return-list.js